import { MissionToExternalStaff } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff'
import { MissionToExternalStaffParams } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff-params'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function confirmExternalStaff(input: MissionToExternalStaffParams) {
  const { id, externalStaffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.confirmExternalStaff.url, { id, externalStaffId }))
    .post<MissionToExternalStaff>()
}
